import { render, staticRenderFns } from "./Animation.vue?vue&type=template&id=396c964a&scoped=true&"
import script from "./Animation.vue?vue&type=script&lang=js&"
export * from "./Animation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396c964a",
  null
  
)

export default component.exports